// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".survey-statistics{position:relative;display:block;padding:10px}.survey-statistics--classic{background-color:#fff;color:#262626;border:5px solid #216096}.survey-statistics--classic .survey-statistics__question__choice__title__content{color:#535353}.survey-statistics--light{background-color:#fff;color:#262626}.survey-statistics--light .survey-statistics__question__choice__title__content{color:#535353}", ""]);
// Exports
module.exports = exports;
